/**
 * BannerIcon entity model class
 *
 * This file is part of Minasa
 * (c) Kaden und Partner AG
 */
import BaseModel from './BaseModel';
import BaseCollection from './BaseCollection';

export class BannerIcon extends BaseModel {
    defaults() {
        return {
            icon: null,
            title: null,
            iconUrl: null,
            defaultIconUrl: null,
            iconBackgroundColor: null,
        };
    }

    entityName() {
        return 'BannerIcon';
    }

    options() {
        return {
            identifier: 'icon',
        };
    }
}

export class BannerIconCollection extends BaseCollection {
    options() {
        return {
            model: BannerIcon,
        };
    }

    entityName() {
        return 'BannerIcon';
    }

    queryUrl() {
        return `/banner/bannerIcons`;
    }
}
